// The Popover API arrived in Safari/iOS 17, above our 15.4 floor, so call it only through these
// (eslint.config.js enforces it). Checked on each call, not once at import, so specs that stub it
// before rendering are seen.
export function supportsPopover(): boolean {
  // eslint-disable-next-line no-restricted-properties -- the feature check itself
  return typeof HTMLElement.prototype.showPopover === "function";
}

/**
 * Puts a `popover` element in the top layer. Without the Popover API the browser ignores the
 * attribute and would always show the element, so it's shown and hidden with `hidden` instead.
 */
export function showPopover(element: HTMLElement) {
  if (!supportsPopover()) element.hidden = false;
  // eslint-disable-next-line no-restricted-properties -- the guarded call this module exists for
  else if (element.isConnected) element.showPopover();
}

export function hidePopover(element: HTMLElement) {
  if (!supportsPopover()) element.hidden = true;
  // eslint-disable-next-line no-restricted-properties -- the guarded call this module exists for
  else if (element.isConnected) element.hidePopover();
}
